export const DataLocales = [
  {
    value: "zh-CN",
    label: "Chinese - China",
  },
  {
    value: "en",
    label: "English",
  },
  {
    value: "en-US",
    label: "English - United States",
  },
  {
    value: "en-150",
    label: "English - Europe",
  },
  {
    value: "en-AU",
    label: "English - Australia",
  },
  {
    value: "en-BE",
    label: "English - Belgium",
  },
  {
    value: "en-CA",
    label: "English - Canada",
  },
  {
    value: "en-GB",
    label: "English - Great Britain",
  },
  {
    value: "en-HK",
    label: "English - Hong Kong SAR China",
  },
  {
    value: "en-IN",
    label: "English - India",
  },
  {
    value: "en-IE",
    label: "English - Ireland",
  },
  {
    value: "en-MY",
    label: "English - Malaysia",
  },
  {
    value: "en-NZ",
    label: "English - New Zealand",
  },
  {
    value: "en-PH",
    label: "English - Philippines",
  },
  {
    value: "en-SG",
    label: "English - Singapore",
  },
  {
    value: "en-ZA",
    label: "English - South Africa",
  },
  {
    value: "fr",
    label: "French",
  },
  {
    value: "fr-CA",
    label: "French - Canada",
  },
  {
    value: "fr-CH",
    label: "French - Switzerland",
  },
  {
    value: "es",
    label: "Spanish",
  },
  {
    value: "es-US",
    label: "Spanish - America",
  },
  {
    value: "sr",
    label: "Serbian",
  },
];
